<div class="flex-auto flex items-center container justify-content-center"  *ngIf="user && user['center_type'] === 'NORMAL'">
  <div class="text-[16px] md:text-[16px] md:font-medium text-center sm:block subheading-2">
    <span [style.font-family]="'var(--vex-font)'">Powered by </span>
    <span class="text-info cursor-pointer"
          (click)="openUrl('https://arni.in/')">Volmint Technologies Pvt ltd.</span>
  </div>
</div>
